// @vendors
import { useTranslation } from 'react-i18next';

const SatisfactionGraph = () => {
    const { t } = useTranslation();

    return (
        <div className="w-full bg-white dark:bg-dark-cBackground p-6 rounded-lg shadow-md">
            <h3 className="text-[16px] font-semibold mb-4 dark:text-dark-cText">
                {t("professional.dashboard.satisfactionTitle")}
            </h3>
            <img
                src="/assets/img/graph.svg"
                alt="Customer Satisfaction Chart"
                className="w-full h-[150] object-cover rounded-md"
            />
            <div className="flex justify-center m-8">
                <h1 className='text-[22px] font-semibold text-gray-400'>Muy pronto</h1>
               {/*  <div>
                    <p className="text-sm text-gray-600 dark:text-dark-cText/60">{t("professional.dashboard.lastMonth")}</p>
                    <p className="font-semibold dark:text-dark-cText">4.8</p>
                </div>
                <div>
                    <p className="text-sm text-gray-600 dark:text-dark-cText/60">{t("professional.dashboard.thisMonth")}</p>
                    <p className="font-semibold dark:text-dark-cText">4.9</p>
                </div> */}
            </div>
        </div>
    )
}

export default SatisfactionGraph